import { ApiService } from '@/services/api.service';

export default {
  namespaced: true,
  state: {
    roleName: null,
    navPermissions: null,
    programs: null,
    programName: null,
    programImage: null,
    programStyle: null,
  },
  getters: {},
  mutations: {
    SET_NAV_PERMISSIONS: (state, data) => {
      if (data) {
        state.navPermissions = data;
      }
    },
  },
  actions: {
    getEntity: (store, { domain, entity }) =>
      new Promise((resolve, reject) => {
        ApiService.get(`/domains/${domain}/${entity}`, {})
          .then(({ data }) => {
            resolve(data.entities);
          })
          .catch((error) => {
            reject(error.response);
          });
      }),
    getPrograms: (store, { entity }) =>
      new Promise((resolve, reject) => {
        ApiService.get(`/domains/programs/${entity}`, {})
          .then(({ data }) => {
            resolve(data);
          })
          .catch((error) => {
            reject(error.response);
          });
      }),
    getNavPermissions: ({ commit }, { domain }) =>
      new Promise((resolve, reject) => {
        ApiService.get(`/roles/nav?domain=${domain}`, {})
          .then(({ data }) => {
            commit('SET_NAV_PERMISSIONS', data.navigation);
            resolve(data.navigation);
          })
          .catch((error) => {
            reject(error.response);
          });
      }),
  },
};
